import React from 'react';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import './Terminal.css';

function App() {
  return (
    <div className="terminal-container">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default App;
